import { useCallback, useMemo } from 'react';
import { useMemorizedCacheTags } from '../../../../hooks/useMemorizedCacheTag';
import { useSubjectUsageQuery } from '../../../../types/planung-graphql-client-defs';

/**
 * Sagt für die genannten Fächer, ob sie in Zuordnungen oder Sollstunden verwendet werden.
 * Ein verwendetes Fach lässt sich nicht löschen; das Backend lehnt es mit DELETE_BLOCKED ab.
 */
export const useSubjectUsage = (uuids: string[]) => {
  const context = useMemorizedCacheTags(['SUBJECTS', 'LESSONS', 'CURRICULA']);

  const [{ data }] = useSubjectUsageQuery({
    variables: { uuids },
    pause: uuids.length === 0,
    context,
  });

  const usedUuids = useMemo(
    () =>
      new Set(
        data?.subjectUsage
          .filter((usage) => usage.lessonsCount > 0 || usage.curriculaCount > 0)
          .map((usage) => usage.uuid),
      ),
    [data],
  );

  return useCallback((uuid: string) => usedUuids.has(uuid), [usedUuids]);
};
